"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateFromYearFracAndStartDate = exports.calculateNoOfMonths = exports.calculateYearFrac = exports.dayCountFromAlias = exports.DayCounts = void 0;
const DATE_MOMENT_FORMAT = 'YYYY-MM-DD';
class DayCounts {
    constructor() {
        this['30/360'] = '30/360';
        this['ACT/360'] = 'ACT/360';
        this['ACT/365'] = 'ACT/365';
        this['ACT/ACT'] = 'ACT/ACT';
        this['30E/360'] = '30E/360';
    }
}
exports.DayCounts = DayCounts;
const DAY_COUNT_ALIASES = {};
function isValidDayCount(name) {
    const dummy = new DayCounts();
    return Object.keys(dummy).indexOf(name) > -1;
}
function dayCountFromAlias(alias) {
    alias = alias.toUpperCase();
    if (isValidDayCount(alias)) {
        return alias;
    }
    alias = DAY_COUNT_ALIASES[alias];
    if (isValidDayCount(alias)) {
        return alias;
    }
    throw Error('Invalid DayCount:' + alias);
}
exports.dayCountFromAlias = dayCountFromAlias;
/*
Inputs expected:
    Dates in YYYY-MM-DD format
    The day count necessary for the calculation of year frac
Output is the year fraction as number
*/
function calculateYearFrac(startDate, endDate, inputDC) {
    let yearFrac = 0.0;
    switch (inputDC) {
        case '30/360':
            yearFrac =
                ((endDate.getYear() -
                    startDate.getYear()) * 360 +
                    (endDate.getMonth() -
                        startDate.getMonth()) * 30 +
                    (Math.min(endDate.getDate(), 30) -
                        Math.min(startDate.getDate(), 30))) / 360;
            break;
        case '30E/360':
            let dayOfStartDate = startDate.getDate();
            let dayOfEndDate = endDate.getDate();
            if (startDate.lastDayOfMonth().isSame(startDate)) {
                dayOfStartDate = 30;
            }
            if (endDate.lastDayOfMonth().isSame(endDate)) {
                dayOfEndDate = 30;
            }
            yearFrac =
                ((endDate.getYear() -
                    startDate.getYear()) * 360 +
                    (endDate.getMonth() -
                        startDate.getMonth()) * 30 +
                    (dayOfEndDate -
                        dayOfStartDate)) / 360;
            break;
        case 'ACT/360':
            yearFrac = endDate.getDaysDiff(startDate, true) / 360;
            break;
        case 'ACT/365':
            yearFrac = endDate.getDaysDiff(startDate, true) / 365;
            break;
        case 'ACT/ACT':
            const endDateFirstDayOfYear = endDate.firstDayOfYear();
            const startDateFirstDayOfYear = startDate.firstDayOfYear();
            yearFrac =
                (endDateFirstDayOfYear.getDaysDiff(startDate, true) /
                    startDateFirstDayOfYear.addMonths(12).getDaysDiff(startDateFirstDayOfYear))
                    +
                        (endDate.getDaysDiff(endDateFirstDayOfYear, true) /
                            endDateFirstDayOfYear.addMonths(12).getDaysDiff(endDateFirstDayOfYear));
            break;
    }
    return yearFrac;
}
exports.calculateYearFrac = calculateYearFrac;
function calculateNoOfMonths(startDate, endDate, inputDC) {
    let yearFrac = 0.0;
    switch (inputDC) {
        case '30/360':
            yearFrac =
                ((endDate.getYear() -
                    startDate.getYear()) * 360 +
                    (endDate.getMonth() -
                        startDate.getMonth()) * 30 +
                    (Math.min(endDate.getDate(), 30) -
                        Math.min(startDate.getDate(), 30))) / 30;
            break;
        case '30E/360':
            let dayOfStartDate = startDate.getDate();
            let dayOfEndDate = endDate.getDate();
            if (startDate.lastDayOfMonth().isSame(startDate)) {
                dayOfStartDate = 30;
            }
            if (endDate.lastDayOfMonth().isSame(endDate)) {
                dayOfEndDate = 30;
            }
            yearFrac =
                ((endDate.getYear() -
                    startDate.getYear()) * 360 +
                    (endDate.getMonth() -
                        startDate.getMonth()) * 30 +
                    (dayOfEndDate -
                        dayOfStartDate)) / 30;
            break;
        case 'ACT/360':
            yearFrac = endDate.getMonthDiff(startDate, false);
            break;
        case 'ACT/365':
            yearFrac = endDate.getMonthDiff(startDate, false);
            break;
        case 'ACT/ACT':
            yearFrac = endDate.getMonthDiff(startDate, false);
            break;
    }
    return yearFrac;
}
exports.calculateNoOfMonths = calculateNoOfMonths;
function getDateFromYearFracAndStartDate(startDate, yearFrac, inputDC) {
    switch (inputDC) {
        case 'ACT/365':
            return startDate.addDays(365.0 * yearFrac);
        case 'ACT/360':
            return startDate.addDays(360.0 * yearFrac);
        case '30/360':
            const noOfYears30360 = Math.floor(yearFrac);
            const noOfMonths30360 = Math.floor((yearFrac - noOfYears30360) * 360 / 30);
            const noOfDays30360 = (((yearFrac - noOfYears30360) * 360 / 30) - Math.floor((yearFrac - noOfYears30360) * 360 / 30)) * 30;
            return startDate.addMonths(noOfYears30360 * 12).addMonths(noOfMonths30360).addDays(noOfDays30360);
        case '30E/360':
            const noOfYears30E360 = Math.floor(yearFrac);
            const noOfMonths30E360 = Math.floor((yearFrac - noOfYears30E360) * 360 / 30);
            const noOfDays30E360 = (((yearFrac - noOfYears30E360) * 360 / 30) - Math.floor((yearFrac - noOfYears30E360) * 360 / 30)) * 30;
            return startDate.addMonths(noOfYears30E360 * 12).addMonths(noOfMonths30E360).addDays(noOfDays30E360);
        default:
            return startDate.addDays(365.0 * yearFrac);
    }
}
exports.getDateFromYearFracAndStartDate = getDateFromYearFracAndStartDate;
//# sourceMappingURL=daycount.js.map